var React = require('react');

function MemoryMatchX (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Path 534","d":"m277.348 170.813 9.551 11.824","fill":"none","stroke":"#a02f2f","strokeLinecap":"round","strokeWidth":"3","key":0}),React.createElement("path",{"data-name":"Path 533","d":"m286.506 170.753-8.878 11.63","fill":"none","stroke":"#a02f2f","strokeLinecap":"round","strokeWidth":"3","key":1})]);
}

MemoryMatchX.defaultProps = {"viewBox":"274.572 168.447 15.198 16.852"};

module.exports = MemoryMatchX;

MemoryMatchX.default = MemoryMatchX;
